/**
 * @see https://stackoverflow.com/questions/41102060/typescript-extending-error-class
 * @see https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
 */
class HttpServiceError extends Error {
  constructor(readonly response: Response) {
    // 'Error' breaks prototype chain here
    super(`Fetch Response status='${response.status}', statusText='${response.statusText}', url='${response.url}'`);

    // restore prototype chain
    const actualProto = new.target.prototype;

    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      (this as any).__proto__ = actualProto;
    }
  }
}

export default HttpServiceError;
